import React, { useState } from 'react';

// Shared shell for both onboarding carousels — dots, a skip link, and a
// primary button that advances until the last slide, where it becomes the
// slide's own call to action.
const OnboardingCarousel = ({ slides, onDone, onSkip }) => {
  const [i, setI] = useState(0);
  const isLast = i === slides.length - 1;

  return (
    <div className="fixed inset-0 z-[100] bg-ink-overlay/90 backdrop-blur-sm flex items-center justify-center p-5 animate-in fade-in duration-200">
      <div className="bg-ink-card2 w-full max-w-sm rounded-3xl border border-white/10 shadow-2xl overflow-hidden flex flex-col animate-in zoom-in-95 duration-200">
        <div className="flex justify-end p-4 pb-0">
          <button
            onClick={onSkip}
            className="text-[11px] font-mono font-medium text-ink-fg/35 hover:text-ink-fg/60 uppercase tracking-widest transition-colors"
          >
            Skip
          </button>
        </div>

        <div className="px-6 pb-2 min-h-[220px] flex items-center">
          <div key={i} className="w-full animate-in fade-in slide-in-from-right-2 duration-200">
            {slides[i].content}
          </div>
        </div>

        <div className="p-6 pt-4">
          <div className="flex items-center justify-center gap-1.5 mb-5">
            {slides.map((_, idx) => (
              <div
                key={idx}
                className={`h-1.5 rounded-full transition-all ${idx === i ? 'w-6 bg-mint' : 'w-1.5 bg-white/15'}`}
              />
            ))}
          </div>
          <button
            onClick={() => (isLast ? onDone() : setI(idx => idx + 1))}
            className="w-full h-12 rounded-2xl bg-mint text-ink-shell font-bold text-sm hover:brightness-95 transition-all active:scale-95"
          >
            {isLast ? slides[i].cta || "Let's go" : 'Next'}
          </button>
        </div>
      </div>
    </div>
  );
};

// Soft glow behind whatever's inside — used to mark "this is the button we mean".
export const Spotlight = ({ children }) => (
  <span className="relative inline-flex">
    <span className="absolute -inset-2 rounded-2xl bg-mint/25 blur-md" />
    <span className="relative">{children}</span>
  </span>
);

export default OnboardingCarousel;
